<div class="message-container">
  <fa-icon [icon]="faExclamationTriangle"></fa-icon>
  <span>{{message | translate}}</span>
</div>
